export default "/img/BF.bb435ac5fc537ba024bdc32133d0c3ea.png";